import React, { Component } from 'react';
import settings from '../configs/settings';
import helpers from '../helpers/index';
import NavTop from '../components/nav-top';
import ActivityIndicator from '../components/activity-indicator';
import ModalEditSuperAccount from '../components/super-accounts/modal-edit-super-account';
import { cloneDeep } from 'lodash';
import account_api from '../api/user-account-api';
import route_helper from '../route-helper';
import { radix_bases } from '../helpers/helper-number-bases';
import file_api from '../api/file-api';
import axios from 'axios';
import AccountTabDisplay from '../components/accounts/account-tab-display';

const types = ["trial_org"];

const static_org = {
  id: null,
  org_name: null,
  org_type: null,
  units: null,
  password_reset_timeframe: null,
  default_partner_view: null,
  auto_logout_time: null,
  logo: null,
  clinician_id: null,
  parent_org: null,
  license_id: null,
  is_locked: false,
  show_gender_identity: false,

  license: {
    id: null,
    boadicea: false,
    tyrer_cuzick: false,
    gail: false,
    claus: false,
    brcapro: false,
    mmrpro: false,
    pancpro: false,
    melapro: false
  },
  clinician_code: {
    id: null,
    code: null
  },
  parent_organization: null,
  contract_start_date: '',
  renewal_date: '',
  specialty: '',
  key_contacts: '',
  contract_summary: '',
  notes: '',
  client_type: '',
  customizations: {
    disease_list: false,
    surveys: false,
  },
  integration_api: {
    auto_invite: false,
    emr: false,
    xml_export: false,
    sso: false,
    other: false,
    other_val_string: ''
  },
  white_label_options: {
    terms_and_conditions: false,
    support_web_page: false,
    automatic_opt_in_patients: false,
    automatic_opt_in_family_members: false,
    hide_clinicians: false,
    hide_risk: false,
    genetic_resources: false,
  },
  trial_expiration: null,
};

function parseToInt(val) {
  return parseInt(val, radix_bases.base10);
}

class SuperAccountPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      org: static_org,
      showEditSuperOrgModal: false,
      loading: false,
      surveys: [],
      survey_display: [],
      survey_options: []
    };
    this.toggleEditSuperOrgModal = this.toggleEditSuperOrgModal.bind(this);
    this.onSaveSuperOrg = this.onSaveSuperOrg.bind(this);
    this.newSubOrg = this.newSubOrg.bind(this);
    this.viewSubOrg = this.viewSubOrg.bind(this);
    this.uploadFiles = this.uploadFiles.bind(this);
    this.saveLogoUrl = this.saveLogoUrl.bind(this);
    this.routeToOrgPage = this.routeToOrgPage.bind(this);
  }

  async componentDidMount() {
    helpers.setSiteTitle('Super Account');

    const org_id = this.props.match.params.org_id;
    if(parseToInt(org_id)) {
      this.setState({loading: true});

      try {
        let survey_options = await account_api.get_surveys();
        survey_options = survey_options.map((survey) => {
          return {value: survey.id, label: survey.name}
        });
        // calling by iteself because it wasn't working when combined with other state
        this.setState({survey_options: survey_options});

        const org_data = await account_api.get_org_by_id(org_id);

        const org_surveys = await account_api.get_org_surveys(org_data.clinician_code.id);

        const survey_names = []
        for (let i = 0; i < org_surveys.length; i++) {
          survey_names.push(org_surveys[i].survey_id.name)
          if (i < org_surveys.length-1) {
            survey_names.push(', ')
          }
        }

        const prev_surveys = []
        for (let i=0; i < org_surveys.length; i++) {
          for (let j=0; j < this.state.survey_options.length; j++) {
            if (org_surveys[i].survey_id.id == this.state.survey_options[j].value) {
              prev_surveys.push(this.state.survey_options[j]);
            }
          }
        }

        this.setState({
          org: {
            ...org_data.org,
            license: org_data.license,
            clinician_code: org_data.clinician_code,
            customizations: org_data.customization,
            integration_api: org_data.integration_api,
            white_label_options: org_data.white_label_option
          },
          survey_display: survey_names,
          surveys: prev_surveys
        });

        if (this.state.org.org_type) {
          if (types.includes(this.state.org.org_type)) {
            const trial_org = await account_api.get_trial_org(org_id);
            this.setState({
              org: {
                ...this.state.org,
                trial_expiration: trial_org
              }
            });
          }
        }

      } catch (error) {
        console.log(error);
      } finally {
        this.setState({loading: false});
      }

    }
  }

  setOrgLicenseState(payload){
    console.log(payload)
    this.setState({
      org: {
        ...this.state.org,
        contract_start_date: payload.contract_start_date,
        renewal_date: payload.renewal_date,
        specialty: payload.specialty,
        key_contacts: payload.key_contacts,
        contract_summary: payload.contract_summary,
        notes: payload.notes,
        client_type: payload.client_type,
        customizations: payload.customizations,
        integration_api: {
          auto_invite: payload.integration_api.auto_invite,
          emr: payload.integration_api.emr,
          xml_export: payload.integration_api.xml_export,
          sso: payload.integration_api.sso,
          other: payload.integration_api.other,
          other_val_string: payload.integration_api.other_val
        },
        white_label_options: payload.white_label_options,
        license: {
          ...this.state.org.license,
          boadicea: payload.risk_models.boadicea,
          tyrer_cuzick: payload.risk_models.tyrer_cuzick,
          gail: payload.risk_models.gail,
          claus: payload.risk_models.claus,
          brcapro: payload.risk_models.brcapro,
          mmrpro: payload.risk_models.mmrpro,
          pancpro: payload.risk_models.pancpro,
          melapro: payload.risk_models.melapro
        },
      }
    })
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (prevProps.location.pathname !== this.props.location.pathname) {
  //     this.componentDidMount();
  //   }
  // }

  newSubOrg() {
    const url = {
      pathname: route_helper.administrative.fh_new_account,
      state: {superOrgId: this.state.org.id}
    };
    this.props.history.push(url);
  }

  viewSubOrg(org_id) {
    const url = route_helper.administrative.fh_sub_account.replace(':org_id', org_id);
    this.props.history.push(url);
  }

  toggleEditSuperOrgModal(event) {
    this.setState({showEditSuperOrgModal: !this.state.showEditSuperOrgModal});
  }

  async routeToOrgPage(org_type, org_id) {
    // Redirect to sub Page if now a sub org
    if(org_type === settings.app_constants.subOrg.value) {
      this.props.history.push(route_helper.administrative.fh_sub_account.replace(':org_id', org_id));
    }
  }

  async onSaveSuperOrg(org) {
    let cloned = cloneDeep(org);
    const { license, clinician_code } = cloned;
    delete cloned.license;
    delete cloned.clinician_code;

    const new_logo = cloned.newLogo;
    delete cloned.newLogo;

    const surveys = cloned.surveys;
    delete cloned.surveys;

    //check if max number of pedigrees is empty, if yes, set to null
    if(!(/\S/.test(cloned.max_number_of_pedigrees))){
      cloned.max_number_of_pedigrees = null;
    }

    // send saved data to the server
    const json = {
      org_name: cloned.org_name,
      org_type: cloned.org_type,
      units: cloned.units,
      dial_code: cloned.dial_code,
      password_reset_timeframe: cloned.password_reset_timeframe,
      auto_logout_time: cloned.auto_logout_time,
      logo: cloned.logo,
      is_locked: cloned.is_locked,
      parent_org: cloned.parent_org ? cloned.parent_org : null,
      show_gender_identity: cloned.show_gender_identity,
      race_ethnicity_display: cloned.race_ethnicity_display,
      risk_model_years: cloned.risk_model_years,
      number_of_licenses: cloned.number_of_licenses,
      max_number_of_pedigrees: cloned.max_number_of_pedigrees,
      default_partner_view: cloned.default_partner_view
    };
    const org_data = await account_api.patch_organization(this.state.org.id, json);

    const code = (clinician_code) ? clinician_code.code : null;
    let clinician_code_data = null;
    if(clinician_code && clinician_code.id && code) {
      clinician_code_data = await account_api.patch_clinician_code(clinician_code.id, {code: code});
    }

    let license_data = null;
    if(license && license.id) {
      license_data = await account_api.patch_license(license.id, {
        boadicea: license.boadicea,
        tyrer_cuzick: license.tyrer_cuzick,
        gail: license.gail,
        claus: license.claus,
        brcapro: license.brcapro,
        mmrpro: license.mmrpro,
        pancpro: license.pancpro,
        melapro: license.melapro
      });
    }

    const survey_ids = surveys.map((survey) => {
      return survey.value
    });

    const survey_orgs = await account_api.save_org_surveys(clinician_code.id, survey_ids);

    const org_surveys = await account_api.get_org_surveys(clinician_code.id);

    let survey_options = await account_api.get_surveys();
    survey_options = survey_options.map((survey) => {
      return {value: survey.id, label: survey.name}
    });
    // calling by iteself because it wasn't working when combined with other state
    this.setState({survey_options: survey_options});

    const survey_names = []
    for (let i = 0; i < org_surveys.length; i++) {
      survey_names.push(org_surveys[i].survey_id.name)
      if (i < org_surveys.length-1) {
        survey_names.push(', ')
      }
    }

    const prev_surveys = []
    for (let i=0; i < org_surveys.length; i++) {
      for (let j=0; j < this.state.survey_options.length; j++) {
        if (org_surveys[i].survey_id.id == this.state.survey_options[j].value) {
          prev_surveys.push(this.state.survey_options[j]);
        }
      }
    }

    this.setState({
      org: {
        ...org_data,
        license: (license_data) ? license_data : license,
        clinician_code: (clinician_code_data) ? clinician_code_data : clinician_code
      },
      survey_display: survey_names,
      surveys: prev_surveys
    });

    if (this.state.org.org_type) {
      if (types.includes(this.state.org.org_type)) {
        const trial_org = await account_api.get_trial_org(org.id);
        this.setState({
          org: {
            ...this.state.org,
            trial_expiration: trial_org
          }
        })
      }
    }

    if(new_logo) {
      await this.uploadFiles(new_logo, org_data);
    } else {
      this.routeToOrgPage(org_data.org_type, org_data.id);
    }
  }

  async uploadFiles(org_logo, org) {
    // Send data to ap server for presigned url
    // uplaod to S3
    // if successful save the logo url to the orgs url field
    // if unsuccessful then delete the file record that was created in the DB

    let response = await file_api.upload_org_logo({
      original_filename: org_logo.name,
      custom_filename: org_logo.name,
      mime_type: org_logo.type,
      file_size: org_logo.size,
      file_note: null,
      file_category: null
    });

    if ('data' in response) {
      const aws_s3 = response.data.s3;
      const public_url = aws_s3.url + aws_s3.fields.key;

      const formData = new FormData();
      for (const key in aws_s3.fields) {
        formData.append(key, aws_s3.fields[key]);
      }
      // formData.append("key", aws_s3.fields.key);
      // formData.append("x-amz-algorithm", aws_s3.fields['x-amz-algorithm']);
      // formData.append("x-amz-credential", aws_s3.fields['x-amz-credential']);
      // formData.append("x-amz-date", aws_s3.fields['x-amz-date']);
      // formData.append("policy", aws_s3.fields.policy);
      // formData.append("x-amz-signature", aws_s3.fields['x-amz-signature']);
      // formData.append("acl", aws_s3.fields.acl);
      formData.append("file", org_logo, org_logo.name);

      axios.post(aws_s3.url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => {
        // success
        this.saveLogoUrl(public_url, org);
      })
      .catch((error) => {
        // delete the record in s3files table in db because the post to S3 failed
        // we do not want a lingering record not pointing to an actual S3 file
        file_api.delete_user_file_from_db(response.data.file_record.id);
        this.routeToOrgPage(org.org_type, org.id);
        return null;
      });
    }
    return null;
  }

  async saveLogoUrl(public_url, org) {
    if(public_url) {
      // send saved data to the server
      const json = {
        org_name: org.org_name,
        org_type: org.org_type,
        units: org.units,
        dial_code: org.dial_code,
        password_reset_timeframe: org.password_reset_timeframe,
        auto_logout_time: org.auto_logout_time,
        logo: public_url,
        is_locked: org.is_locked,
        parent_org: org.parent_org
      };
      const org_data = await account_api.patch_organization(org.id, json);

      this.setState({
        org: {
          ...org_data,
          license: this.state.org.license,
          clinician_code: this.state.org.clinician_code
        }
      });
    }
    this.routeToOrgPage(org.org_type, org.id);
  }


  render() {

    let showEdit = '';
    if(this.props.location.state == undefined){
      showEdit = true
    } else if(this.props.location.state.fromAccount){
      showEdit = false
    }

    return (
      <React.Fragment>

        <NavTop history={this.props.history} />

        <section className="wow fadeIn section animated" style={{paddingBottom: '0px', visibility: 'visible', animationName: 'fadeIn'}}>
        	<div className="container">

        		<div className="section-header">
        			<div className="row vcenter">
        				<div className="col-md-6 col-xs-12">
        					<h2>{this.state.org.org_name}</h2>
        				</div>
        				<div className="col-md-4 col-md-offset-2 justify-right hidden"></div>
        			</div>
        		</div>

              <AccountTabDisplay
                org={this.state.org}
                setOrgLicenseState={(payload) => this.setOrgLicenseState(payload)}
                showEdit={showEdit}
                toggleEditSuperOrgModal={this.toggleEditSuperOrgModal}
                survey_display={this.state.survey_display}
                showFilter={true}
                headerBtnCssClass="btn btn-light btn-xs"
                org_id={this.state.org.id}
                newSubOrg={this.newSubOrg}
                viewSubOrg={(org_id) => this.viewSubOrg(org_id)}
                isSuperAdmin={true}
              />

        	</div>
        </section>

        {this.state.showEditSuperOrgModal &&
          <ModalEditSuperAccount
            org={this.state.org}
            onClose={this.toggleEditSuperOrgModal}
            onClickSave={(payload) => this.onSaveSuperOrg(payload)}
            selected_surveys={this.state.surveys}
          />
        }

        <ActivityIndicator
          loading={this.state.loading}
          modal={true}
        />

      </React.Fragment>

    );
  }
}

export default SuperAccountPage;
